<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="form">
  <label>{{ 'INDUSTRIES_SELECT.INDUSTRIES' | translate }}</label>
  <ng-select
    [multiple]="true"
    [items]="data | async"
    bindLabel="formattedName"
    bindValue="id"
    [loading]="loader"
    [formControlName]="'industries_fake'"
    (add)="add($event)"
    (remove)="remove($event.value.id)"
    (clear)="clear()"
    [typeahead]="input$"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="event-select-option-wrapper">
        <div class="event-name">{{ item.name }}</div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
      </div>
    </ng-template>
  </ng-select>
</div>
